// components/ui/Modal.tsx
import React from 'react';
import { ModalProps } from '../../types/index';

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, imageUrl, altText, caption }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-[100] p-4"
      onClick={onClose}
    >
      <div
        className="bg-white p-4 rounded-lg shadow-xl max-w-3xl max-h-[90vh] overflow-auto relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-600 hover:text-gray-900 text-3xl font-bold z-[101]"
          aria-label="Close image viewer"
        >
          &times;
        </button>
        <img
          src={imageUrl}
          alt={altText}
          className="w-full h-auto object-contain rounded-md max-h-[75vh]"
          onError={(e) => (e.currentTarget.src = 'https://placehold.co/800x600/cccccc/333333?text=Image+Load+Error')}
        />
        {caption && <p className="text-center text-gray-700 mt-3">{caption}</p>}
      </div>
    </div>
  );
};

export default Modal;
